import { render, staticRenderFns } from "./QuizUpload.vue?vue&type=template&id=bc786ef0&"
import script from "./QuizUpload.vue?vue&type=script&lang=js&"
export * from "./QuizUpload.vue?vue&type=script&lang=js&"
import style0 from "./QuizUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports